import server from "./server";

export const getFeaturesApi = async () => {
  const response = await server().get("/features");
  return response.data;
};
